// -------------------------------------------------    -------------------------
// #55 - Wild Challenge hero module
// --------------------------------------------------------------------------
// Author:      Thomas Jeatt
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {

        var closeHeroFormElement = context.find('[data-binding="wild-challenge-close-hero-form"]');
        var closeHeroForm = closeHeroFormElement.find('form');
        var closeHeroFormButton = closeHeroForm.find('[data-binding="wild-challenge-close-hero-button"]');
        var ctaButton = context.find('[data-binding="wild-challenge-cta-button"]');

        closeHeroForm.on('submit', function (e) {
            e.preventDefault();

            $.ajax({
                data: closeHeroForm.serialize() + '&' + closeHeroFormButton.attr('name') + '=',
                type: closeHeroForm.attr('method'),
                url: closeHeroForm.attr('action')
            });

            /// Removed on click rather than success to avoid a delay in the module disappearing when the user clicks the close icon
            context.remove();
        });

        ctaButton.on('click', function () {
            closeHeroForm.submit();
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/wild-challenge/wild-challenge-close-hero.js
// module id = 254
// module chunks = 0